import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../helpers/reducerRegistry'
import { GDP_TAB } from '../../constant'

const slice = createSlice({
  name: 'industry/industryOverview/macroeconomics/viewChart/gdpTable',
  initialState: {
    tab: GDP_TAB.REAL_GDP.key,
  },
  reducers: {
    changeTab: (state, action) => {
      state.tab = action.payload
    },
  },
})

register(slice.name, slice.reducer)

export const selectMacroGDPTable = (state) => state[slice.name]
export const selectTab = (state) => state[slice.name].tab

export const { changeTab } = slice.actions
